import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import JSONModel from "sap/ui/model/json/JSONModel";
import ReportStatisticDialogController from "vamos/cockpit/main/menu/controller/ReportStatisticDialog.controller";
import ViewHandler from "vamos/cockpit/base/handler/ViewHandler";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import { ResponseMenuBatchDto } from "vamos/cockpit/model/api/vamos.private.api.types";
import MaintenanceService from "vamos/cockpit/main/app/service/MaintenanceService";
import { Button$PressEvent } from "sap/m/Button";


export default class MainMenuController extends BaseTypeController {

    private statusFinished = false;

    private statusUpdateAllowed = true;

    private maintenanceService: MaintenanceService;

    public onInit() {
        super.onInit();
        this.maintenanceService = new MaintenanceService(this);
        this.getComponent()
            .getModel("app")
            .bindProperty("/Clients/CurrentClientName")
            .attachChange(() => {
                this.requestMenuStatus();
            });
    }

    public onAfterRendering() {
        this.requestMenuStatus().then().catch();
    }

    public async onRequiredStock(oEvent: Button$PressEvent) {
        this.onNavTo(oEvent);
    }

    private async requestMenuStatus(): Promise<void> {

        if (!this.statusUpdateAllowed) {
            return;
        }

        const apiResonse: ResponseMenuBatchDto = await ApiService.getInstance().getRestJsonData("/menu/status");

        const batchObject = apiResonse.content;

        this.statusFinished = true;
        this.getView().setModel(new JSONModel(batchObject), "badges");
        const inventoryModel = this.getModel("inventory") as JSONModel;
        inventoryModel.setProperty("/inventoryActive", batchObject.inventoryActive);
        if (batchObject.bmecatActive === true) {
            const appModel = this.getModel("app") as JSONModel;
            appModel.setProperty("/maintenance", true);
            this.maintenanceService.runMaintenance();
        }

        this.statusUpdateAllowed = false;
        setTimeout(() => (this.statusUpdateAllowed = true), 2000);
    }

    public async onOpenStatistics() {
        const view = await ViewHandler.getView("vamos.cockpit.main.menu.view.ReportStatisticDialog", this.getComponent());
        const controller = view.getController() as ReportStatisticDialogController;
        controller.openDialog();
    }


}